import React from 'react';
import { observer } from 'mobx-react';
import useStyles from './TextAssetsTab.styles';
import { useTextAssets } from '../../../../hooks';
import { List, ListItem, Typography } from '@material-ui/core';
import { TextAssetBuilder } from './components/TextAssetBuilder/TextAssetBuilder';
import { TextAssetItem } from './components/TextAssetItem/TextAssetItem';

export const TextAssetsTab: React.FC = observer(() => {
  const { activeTabKey, textAssets = [], newTextAsset } = useTextAssets();

  const classes = useStyles(activeTabKey)();

  return (
    <List className={classes.List}>
      {newTextAsset && (
        <ListItem className={classes.ItemRoot}>
          <TextAssetBuilder />
        </ListItem>
      )}
      {!textAssets.length && <Typography classes={{ root: classes.EmptyMsg }}>No Assets Available</Typography>}
      {textAssets.map((textAsset) => (
        <TextAssetItem key={textAsset.id} textAsset={textAsset} />
      ))}
    </List>
  );
});
